import fetch from '../utils/fetch'

//實體訂單列表/自營訂單列表 （備注）
export function remarks ({ orderId, ...restParams }) {
  return fetch({
    url: `/remarks/${orderId}`,
    method: 'put',
    params: restParams
  })
}

//售後列表新增備注功能
export function afterRemarks (params) {
  return fetch({
    url: `/aftersales/remark`,
    method: 'put',
    params: params
  })
}
